<template>
  <div :class="[$style.wrap, fullScreen && $style.fullScreen]">
    <header>
      <span>忘记密码</span>
      <img
        :src="fanhuiIcon"
        :class="$style.fanhui"
        @click="$emit('back')"
      />
    </header>
    <main>
      <div :class="$style.content">
        <div :class="$style.accountWrap">
          <div :class="$style.inputWrap">
            <img :src="shoujiIcon" :class="$style.leftIcon" />
            <input type="number" placeholder="请输入绑定手机号" v-model.trim="form.tel_num" />
          </div>
        </div>
        <div :class="[$style.inputWrap, $style.pwd]">
          <img :src="mimaIcon" :class="$style.leftIcon" />
          <input type="password" placeholder="请输入新密码" v-model.trim="form.password" />
        </div>
        <div :class="[$style.inputWrap, $style.code]">
          <img :src="yanzhengmaIcon" :class="$style.leftIcon" />
          <input type="number" placeholder="请输入验证码" v-model.trim="form.smsCode" />
          <span :class="$style.getCode" v-if="!count" @click="getVerifyCode">获取</span>
          <span :class="$style.getCode" v-else>{{ count }}</span>
        </div>
      </div>
      <button :class="$style.submitBtn" @click="toModify">确认</button>
    </main>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { getSmsCode, forgetPwd } from "@/api/user";
import CryptoJS from "crypto-js";
import { Toast } from "vant";
import isFullScreen from '@/libs/business/fullScreen'
import CountDown from '@/mixins/countDown';
import { regexpVerify } from '@/libs/business/account';

export default {
  data() {
    return {
      fullScreen: '',
      form: {},
      fanhuiIcon: `${this.$cdnLink}/wanXin/orangeTheme/fanhui.png`,
      shoujiIcon: `${this.$cdnLink}/wanXin/orangeTheme/shoujihao.png`,
      mimaIcon: `${this.$cdnLink}/wanXin/orangeTheme/mima.png`,
      yanzhengmaIcon: `${this.$cdnLink}/wanXin/orangeTheme/yanzhengma.png` 
    }
  },
  created() {
    this.fullScreen = isFullScreen();
  },
  mixins: [CountDown],
  mounted() {

  },
  computed: {
    ...mapState({
      appkey: state => state.user.appkey
    })
  },
  methods: {
    async getVerifyCode() {
      await regexpVerify(this.form, [
        { key: 'tel_num', hint: '请输入正确的手机号', type: 'phone' },
      ]);
      await getSmsCode({
        tel_num: this.form.tel_num,
        jh_app_id: this.appkey,
        type: 'reset'
      });
      Toast('发送成功');
      this.setTimer();
    },
    async toModify() {
      const { tel_num, password, smsCode } = this.form;
      await regexpVerify(this.form, [
        { key: 'smsCode', hint: '请输入验证码' },
        { key: 'password', hint: '密码由6-18位数字或字母组成', type: 'password' },
        { key: 'tel_num', hint: '请输入正确的手机号', type: 'phone' },
      ]);
      await forgetPwd({
        tel_num: tel_num,
        jh_app_id: this.appkey,
        code: smsCode,
        password: CryptoJS.MD5(password + CryptoJS.MD5(password)).toString()
      });
      Toast('修改成功');
      setTimeout(() => {
        this.$emit('back');
      }, 1000);
    }
  }
}
</script>
<style lang="scss" module>
@import "../../../assets/css/common.scss";

.wrap {
  @include common-window();
  > header {
    position: relative;
    > span {
      font-weight: 600;
      font-style: italic;
    }
    .fanhui {
      position: absolute;
      top: 0.35rem;
      right: 0.35rem;
      width: 0.34rem;
      height: 0.25rem;
    }
  }
  > main {
    padding-top: 0.35rem;
    .accountWrap {
      position: relative;
    }
    .inputWrap {
      @include common-inputWrap();
      justify-content: flex-start;
      padding-left: 0.25rem;
      .leftIcon {
        margin-right: 0.16rem;
      }
      &.pwd {
        margin-top: 0.12rem;
        margin-bottom: 0.12rem;
        > input {
          width: 3.5rem;
        }
      }
      &.code {
        margin-bottom: 0.34rem;
        > input {
          width: 2.2rem;
        }
        .getCode {
          display: flex;
          align-items: center;
          color: $primary-color;
          border-left: 1px solid $primary-color;
          padding-left: 0.2rem;
          height: 0.5rem;
          font-size: $font-nm-1;
        }
      }
    }
    .redirect {
      display: flex;
      color: $primary-color-1;
      justify-content: space-between;
      width: 4.44rem;
      margin: auto;
      font-size: $font-nm-1;
      > span {
        padding: 0.12rem 0.22rem 0.22rem 0.29rem;
        &:active {
          opacity: 0.8;
        }
      }
    }
    .submitBtn {
      @include common-button();
    }
  }
  &.fullScreen {
    @include full-screen-window();
    > header {
      position: relative;
      > span {
        font-weight: 600;
        font-style: italic;
      }
      .fanhui {
        position: absolute;
        top: 17px;
        right: 17px;
        width: 17px;
        height: 12px;
      }
    }
    > main {
      padding-top: 17px;
      .accountWrap {
        position: relative;
      }
      .inputWrap {
        @include full-screen-inputWrap();
        justify-content: flex-start;
        padding-left: 12px;
        .leftIcon {
          margin-right: 8px;
        }
        &.pwd {
          margin-top: 6px;
          margin-bottom: 6px;
          > input {
            width: 175px;
          }
        }
        &.code {
          margin-bottom: 17px;
          > input {
            width: 110px;
          }
          .getCode {
            display: flex;
            align-items: center;
            color: $primary-color;
            border-left: 1px solid $primary-color;
            padding-left: 10px;
            height: 25px;
            font-size: $font-nm;
          }
        }
      }
      .redirect {
        display: flex;
        color: $primary-color-1;
        justify-content: space-between;
        width: 222px;
        margin: auto;
        font-size: $font-nm;
        > span {
          padding: 6px 11px 11px 14px;
          &:active {
            opacity: 0.8;
          }
        }
      }
      .submitBtn {
        @include full-screen-button();
      }
    }
  }
}
</style>